export default __webpack_public_path__ + "static/media/requisite.960228b7.svg";